import { createContext, useContext, useRef, useState } from 'react';

const ZebraPrinterContext = createContext(null);

const projeto = JSON.parse(sessionStorage.getItem('user'))?.cod_projeto || JSON.parse(sessionStorage.getItem('projeto'))?.projeto;

const optFieldsProduto = {
    endereco: {
        label: 'END'
    },
    renasem: {
        label: 'REN'
    },
    peso: {
        label: 'PB',
        format: v => `${v.toLocaleString('pt-BR', { minimumFractionDigits: 3, maximumFractionDigits: 3 })}KG`
    },
    serial: {
        label: 'LT'
    },
    categoria: {
        label: 'CAT'
    },
    peneira: {
        label: 'PN',
    },
    germinacao: {
        label: 'GE',
        format: v => `${v.toLocaleString('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`
    },
};

export const ZebraPrinterProvider = ({ children }) => {

    const [isConnected, setIsConnected] = useState(false);
    const printer = useRef(null);
    
    const connectPrinter = () => {
        return new Promise((resolve, reject) => {
            try {
                if (window.BrowserPrint) {
                    window.BrowserPrint.getDefaultDevice('printer', (device) => {
                        if (device) {
                            printer.current = device;
                            device.send('! U1 setvar "media.type" "direct_thermal"\n! U1 setvar "print.tone" "30"\n', () => {
                                setIsConnected(true);
                                resolve();
                            }, () => reject('Nenhuma impressora Zebra encontrada. Verifique as configurações do Zebra Browser Printer e as conexões com impressoras.'));
                        } else {
                            reject('Nenhuma impressora Zebra encontrada. Verifique as configurações do Zebra Browser Printer e as conexões com impressoras.');
                        }
                    }, () => {
                        reject('install');
                    });
                } else {
                    reject('Houve algum erro durante o carregamento da página. Feche o site e abra novamente.');
                }
            } catch (error) {
                reject('Erro inesperado. Contate o suporte.');
            }
        });
    };

    const testConnection = () => {
        return new Promise((resolve, reject) => {
            setIsConnected(false);
            printer.current.send('! U1 setvar "media.type" "direct_thermal"\n! U1 setvar "print.tone" "30"\n', 
                () => {
                    setIsConnected(true);
                    resolve();
                }
            );
        });
    };
    
    const printEtiquetas = (etiquetas) => {
        return new Promise((resolve, reject) => {
            if(printer.current){
                let zplCommand;
                etiquetas.forEach((etiqueta) => {
                    if(etiqueta?.produto){
                        const { produto, codref, codbarras, descricao, situacao, validade, nome_cd, cod_cd, saldo } = etiqueta;
                        const validadeFormatada = validade ? validade.split('T')[0].split('-').reverse().join('/') : '';

                        if(Number(projeto) === 44){
                            const codrefText = codref ? `CodRef: ${codref}` : '';
                            const qtdText = saldo != null ? `QTD: ${saldo}` : '';
                            const validadeText = validadeFormatada ? `^CF0,18 ^FO30,155 ^FB180,1,0,C ^FDValidade:${validadeFormatada}^FS` : '';
                            zplCommand += `^XA ^MTT ^JUS ^PW727 ^LL199 ^CI28 ^CF0,28 ^FO20,20 ^BY2,2,85 ^BEN,70,Y,N ^FD${codbarras}^FS ${validadeText} ^CF0,26 ^FO270,20 ^FB470,3,2,L ^FD${descricao}^FS ^CF0,28 ^FO270,110 ^FD${codrefText}^FS ^FO460,110 ^FD${qtdText}^FS ^CF0,16 ^FO250,155 ^FB300,1,0,C ^FD${nome_cd}^FS ^CF0,22 ^FO585,155 ^FDVallysys^FS ^XZ`;
                        }
                        else {
                            const formatedOptFields = [[], []];
                            Object.keys(optFieldsProduto).forEach((key, index) => {
                                if(!etiqueta[key]) return;
                                const { label, format } = optFieldsProduto[key];
                                formatedOptFields[index <= 2 ? 0 : 1].push(`${label}(${format ? format(etiqueta[key]) : etiqueta[key]})`);
                            });
                            zplCommand += `^XA^MTt^JUS^PW727^LL199^A@N,20,10,E:ARIAL.TTF^FWN^CI28^CF0,22^FO20,20^FB690,2,0^FD${descricao}^FS^CFN,20^FO40,65^FB200,1,10,C^FD${situacao}^FS^BY2,3,100^FO40,85^BEN,50,Y,N^FD${codbarras}^FS^CF0,20^FO20,170^FDValidade:${validadeFormatada}^FS^CF0,20^FO280,65^FDProduto: ${produto} ${codref ? `/ CodRef: ${codref}` : ''}^FS^FO280,85^FD${formatedOptFields[0].join(' - ')}^FS^FO280,115^FD${formatedOptFields[1].join(' - ')}^FS^CF0,20^FO280,145^FB330,2,0,C^FD${nome_cd} / CD: ${cod_cd}^FS^CF0,30^FO610,165^FDVallysys^FS^XZ`;
                        }
                    }
                    else {
                        const { codbarras, codigo } = etiqueta;
                        zplCommand += `^XA^MTt^JUS^PW727^LL199^CI28^CF0,100^FO65,35^FB500,1,0,C^FD${codigo}^FS^BY2,2,50^FO130,120^BCN,50,Y,N^FD${codbarras}^FS^BY10,2,1^FO600,20^BQN,2,5^FDLA,${codbarras}^FS^CF0,30^FO610,160^FDVallysys^FS^XZ`;
                    }
                });
                printer.current.send(zplCommand, () => resolve(), () => {
                    setIsConnected(false);
                    reject({ type: 'error', message: 'Houve algum erro no aplicativo Zebra Browser Print!' });
                });
            }
            else reject({ type: 'no_printer', message: 'Nenhuma impressora está configurada com o Zebra Browser Print!' });
        });
    };

    return (
        <ZebraPrinterContext.Provider value={{ connectPrinter, testConnection, printEtiquetas, isConnected }}>
            {children}
        </ZebraPrinterContext.Provider>
    );
};

export const useZebraPrinter = () => {
    return useContext(ZebraPrinterContext);
};